var Lightpick = require('./lightpick-original');
var formValidation = require('../components/formValidation');
var datePicker;

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 */
function displayMessage(data) {
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }

    if (screen.width <= 765) {
        $('.contact-us-signup-message')
            .append(`<div class="alert alert-sm contact-us-signup-message text-center ${status}" role="alert"> 
        <div>
            <span class="icon"> 
                <svg>
                    <use xlink:href="${data.svg}"></use>
                </svg>
            </span>
        </div>
        <div class="alert-text">
            ${data.msg} 
        </div>
        </div>`);
    }
    else {
        $('.contact-us-signup-message')
            .append(`<div class="alert alert-lg d-flex contact-us-signup-message text-center ${status}" role="alert">
        <div>
            <span class="icon"> 
                <svg>
                    <use xlink:href="${data.svg}"></use>
                </svg>
            </span>
        </div>
        <div class="alert-text">
            ${data.msg} 
        </div>
        </div>`);
    }
    
}

/**
 * Load Custom File Attacher behaviour after page reload.
 */
function loadFileAttacher() {
    $('.js-attach-file').on('click', function () {
        $('input#file').trigger('click');
    });

    $('.custom-file-upload input#file').on('change', function (e) {
        var attachedFiles = Array.from($(e.currentTarget)[0].files);
        $('.attached-files-content').empty();
        if (attachedFiles.length > 0) {
            attachedFiles.forEach((file) => {
                var name = file.name;
                var size = file.size;
                var formattedSize;

                if (size < 1024) { // Bytes
                    formattedSize = size + ' B';
                } else { // KB
                    formattedSize = (size / 1024).toFixed(1) + ' KB';
                }

                var attachedFile = $('div#attachedFileTemplate').clone();
                attachedFile.find('.attached-file-info .file-name').text(name);
                attachedFile.find('.attached-file-info .file-size').text(formattedSize);
                attachedFile.find('svg.delete-icon').attr('data-name', name);
                attachedFile
                    .removeAttr('id')
                    .removeClass('d-none')
                    .attr('data-name', name)
                    .addClass('d-flex')
                    .appendTo('.attached-files-content');

                if (size > parseInt($(this).attr('data-maxsize'), 10) * 1024) {
                    $('.file-attacher-error').text('File size exceeds limit.');
                } else {
                    $('.file-attacher-error').empty();
                }

                if (FileReader && file.type.match('image')) {
                    var fileReader = new FileReader();
                    fileReader.onload = function (e) {
                        document.querySelector('.attached-file[data-name="' + name + '"] .attached-file-img').src = e.target.result;
                    };

                    fileReader.readAsDataURL(file);
                }
            });
            $('.attached-files').removeClass('d-none');

            $('.js-remove-attachment').on('click', function () {
                $('input#file').val('');
                $('input#file').trigger('change');
                $('.file-attacher-error').empty();
            });
        } else {
            $('.attached-files').addClass('d-none');
        }
    });
}


/**
 * Load custom radio choose behaviour after page reload
 */
function loadRadioChoose() {
    $('.radio-choose-options').on('click', '.radio-container', function (e) {
        e.preventDefault();
        var $select = $(e.currentTarget).parent().siblings('.form-group').find('select');
        var id = $(e.currentTarget).find('input').prop('id');
        $(e.currentTarget).siblings().find('input').prop('checked', false);
        $(e.currentTarget).find('input').prop('checked', true);

        if ($select.length != 0) {
            $select.find('option').removeProp('selected');
            $select.find('option#' + id).prop('selected', 'selected');
        }

        // Show / Hide Sterilised section
        if (id === 'dog' || id === 'cat') {
            if (id === 'dog') {
                $('.sterilised-section').addClass('d-none');
            } else if (id === 'cat') {
                $('.sterilised-section').removeClass('d-none');
            }

            var $breedSelect = $('select#petBreed');
            var $defaultOption = $breedSelect.find('option:default').clone();
            var url = $breedSelect.attr('data-reloadUrl') + '?animal=' + id;
            $breedSelect.empty();

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    data.animalBreeds.forEach(breed => {
                        var option = '<option id="' + breed.toLowerCase().replace(' ', '_') + '" value="' + breed + '" >' + breed + '</option>';
                        $defaultOption.prependTo($breedSelect);
                        $(option).appendTo($breedSelect);
                    });
                }
            });
        }
    });
}

/**
 * Loads datepicker
 */
function loadDatePicker() {
    // eslint-disable-next-line no-unused-vars
    datePicker = new Lightpick({
        field: document.querySelector('input.datePicker')
    });

    $('.calendar-icon').on('click', function (e) {
        e.stopPropagation();
        $('input.datePicker').trigger('click');
    });
}

/**
 * Converts file to base64
 */
function file2Base64(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader ();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

/**
 * Form serialize and ajax call
 */
function sendForm(form, button, url) {
    $('.is-invalid').removeClass('is-invalid');
    var $policyConfirm = form.find('#policyConfirm');

    if ($policyConfirm.length != 0 && !$policyConfirm.is(':checked')) {
        $policyConfirm.parent().parent('.form-group').addClass('is-invalid');
        $policyConfirm.parent().siblings('.invalid-feedback').show();
    } else {
        $policyConfirm.parent().siblings('.invalid-feedback').hide();
        $.spinner().start();

        if ($('#petWeight').length != 0) {
            formatWeight($('#petWeight'));
        }

        var formData = form.serialize();
        button.attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: formData,
            success: function (data) {
                if (data.success && data.redirectUrl) {
                    displayMessage(data);
                    setTimeout(function () {
                        location.href = data.redirectUrl;
                    }, 3000);
                } else {
                    displayMessage(data);
                    formValidation(form, data);
                }

                $.spinner().stop();

                window.scrollTo({ top: 0, behavior: 'smooth'});
                setTimeout(function () {
                    $('.contact-us-signup-message').remove();
                    button.removeAttr('disabled');
                }, 3000);
            },
            error: function (err) {
                displayMessage(err);
                $.spinner().stop();

                window.scrollTo({ top: 0, behavior: 'smooth'});

                setTimeout(function () {
                    $('.contact-us-signup-message').remove();
                    button.removeAttr('disabled');
                }, 3000);
            }
        });
    }
}

// Form submit function
function subscribeContact() {
    $('button.subscribe-contact-us').on('click', function (e) {
        e.preventDefault();
        var button = $(this);
        var form = button.parent('form');
        var url = form.attr('action');

        var $checkboxChoose = $('.checkbox-choose');
        if ($checkboxChoose.length != 0 && $checkboxChoose.find('.checkbox-container input:checked').length != 0) {
            var healthProblemsFullValue = '';
            $checkboxChoose.find('.checkbox-container input:checked').toArray().forEach((input, index) => {
                healthProblemsFullValue = healthProblemsFullValue + $(input).attr('data-value');
                if (index != $checkboxChoose.find('.checkbox-container input:checked').length -1) {
                    healthProblemsFullValue = healthProblemsFullValue + ', ';
                } else {
                    healthProblemsFullValue = healthProblemsFullValue + '.';
                }
            });

            $checkboxChoose.find('.form-group input').val(healthProblemsFullValue);
        }

        var files = $('input#file').length != 0 ? Array.from($('input#file')[0].files) : [];

        if (files.length != 0) {
            if ($('.file-attacher-error:empty').length != 0) {
                var file = files[0];
                var fileName = file.name;
                var fileSize = file.size;
                file2Base64(file)
                    .then(encodedFile => {
                        $('input#fileName').val(fileName);
                        $('input#fileSize').val(fileSize);
                        $('input#encodedFile').val(encodedFile);

                        sendForm(form, button, url);
                    })
                    .catch(error => {
                        alert('Error:', error);
                    });
            }
        } else {
            sendForm(form, button, url);
        }
    });
}


function orderNumber() {
    $('#orderNumber').on('change', function () {
        var $this = $(this);
        if ($this.val() == 'manual') {
            $('#orderNumberManual').parents('.form-group').removeClass('d-none');
        } else {
            $('#orderNumberManual').val('').parents('.form-group').addClass('d-none');
        }
    });
}

function formatWeight(elem) {
    var val = elem.val();

    if (val.split('.').length == 2 && val.split('.')[1] == '') {
        elem.val(val + '0');
    }
}

function petWeight() {
    $('#petWeight').on('input', function () {
        var currentString = $(this).val();
        var regExp = new RegExp('^[0-9]*\\.?[0-9]*$');

        // accept only numbers and '.' for weight
        // do not use keypress because it is not supported on mobile devices
        if (!regExp.test(currentString)) {
            $(this).val(currentString.substring(0, currentString.length - 1));
        }
    });

    $('#petWeight').on('focusout', function () {
        formatWeight($(this));
    });
}

module.exports = {
    menuButtons: function () {
        $('.js-contactUsMenuBtn').on('click', function () {
            var $this = $(this);
            var url = $this.attr('data-href') + '?id=' + $this.attr('id');
            $.spinner().start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (data) {
                    var backButton = $('.contact-us-back-button');
                    $('.contact-information')
                        .empty()
                        .html(backButton)
                        .append(data);
                    $('.contact-us-back-button')
                        .removeClass('d-none')
                        .addClass('d-flex');
                    $('.contact-menu a').removeClass('active');
                    $('a#' + $this.attr('id')).addClass('active');
                    $('.contact-menu').addClass('option-selected');
                    $.spinner().stop();

                    if ($('.custom-file-upload').length != 0) {
                        loadFileAttacher();
                    }

                    if ($('.radio-choose-options').length != 0) {
                        loadRadioChoose();
                    }

                    if ($('input.datePicker').length != 0) {
                        loadDatePicker();
                    }

                    if ($('#orderNumber').length != 0) {
                        orderNumber();
                    }

                    if ($('#petWeight').length != 0) {
                        petWeight();
                    }

                    subscribeContact();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    $.spinner().stop();
                }
            });
        });
    },
    phoneClick: function () {
        $('.phone-number-contact').on('click', function () {
            $('body').trigger('gtm:c2c', {url: $('.contact-us-url').val()});
        });
    }
};
